<template>
  <keep-alive>
    <layout-page v-if="!isMobileView">
        <up-next-page-desktop/>
    </layout-page>
    <layout-mobile v-else>
      <up-next-page-desktop/>
    </layout-mobile>
  </keep-alive>
</template>

<script>
import UpNextPageDesktop from "./UpNextPageDesktop";

export default {
  name: "UpNextPage",
  metaInfo: {
    title: 'Up Next',
  },
  components: {
    UpNextPageDesktop,
  },
  computed: {
    isMobileView() {
      return this.$store.state.isMobile
    },
  }
}
</script>
